import React from 'react';
import { compose } from 'recompose';

import { NumberBox } from 'devextreme-react/number-box';

import { Typography, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import {
  areEqual,
  getMilesFromMeters,
  getMetersFromMiles,
  getDiameterFromRadius,
  getCircumferenceFromRadius,
  getAreaFromRadius,
} from '../../../../utilities';

function Field({ classes, value, handleChange, name, disabled }) {
  const { numberBox } = classes;

  function onFocusOut(event) {
    const changedValue = event?.component?._changedValue;
    if (changedValue && parseFloat(changedValue) !== value) {
      handleChange(parseFloat(changedValue), name);
    }
  }

  return (
    <NumberBox
      defaultValue={0}
      value={value}
      onFocusOut={onFocusOut}
      className={numberBox}
      disabled={disabled}
    />
  )
}

function CircleDetail({ classes, setManualRadius, radius, disabled }) {
  const { editorContainer, editorTitle, fieldWrapper, units, degree } = classes;

  const convertedRadius = getMilesFromMeters(radius);
  const convertedDiameter = getDiameterFromRadius(radius);
  const convertedCircumference = getCircumferenceFromRadius(radius);
  const convertedArea = getAreaFromRadius(radius);

  function handleManualChange(value, fieldName) {
    switch (fieldName) {
      case 'radius':
        setManualRadius(getMetersFromMiles(value));
        break;
      case 'diameter':
        setManualRadius(getMetersFromMiles(value/2));
        break;
      case 'circumference':
        const manualRadius = (value / 2) / Math.PI;
        setManualRadius(getMetersFromMiles(manualRadius));
        break;
      case 'area':
        const convertedRadius = Math.sqrt((value / Math.PI));
        setManualRadius(getMetersFromMiles(convertedRadius));
        break
      default: return;
    }
  }

  return (
    <>
      <div className={editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={editorTitle}
        >
          Radius
        </Typography>
        <div className={fieldWrapper}>
          <Field
            classes={classes}
            handleChange={handleManualChange}
            value={convertedRadius}
            name="radius"
            disabled={disabled}
          />
          <span className={units}>mi</span>
        </div>
      </div>
      <Divider />
      <div className={editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={editorTitle}
        >
          Diameter
        </Typography>
        <div className={fieldWrapper}>
          <Field
            classes={classes}
            handleChange={handleManualChange}
            value={convertedDiameter}
            name="diameter"
            disabled={disabled}
          />
          <span className={units}>mi</span>
        </div>
      </div>
      <Divider />
      <div className={editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={editorTitle}
        >
          Circumference
        </Typography>
        <div className={fieldWrapper}>
          <Field
            classes={classes}
            handleChange={handleManualChange}
            value={convertedCircumference}
            name="circumference"
            disabled={disabled}
          />
          <span className={units}>mi</span>
        </div>
      </div>
      <Divider />
      <div className={editorContainer}>
        <Typography
          variant="subtitle2"
          color="inherit"
          className={editorTitle}
        >
          Area
        </Typography>
        <div className={fieldWrapper}>
          <Field
            classes={classes}
            handleChange={handleManualChange}
            value={convertedArea}
            name="area"
            disabled={disabled}
          />
          <span className={units}>mi</span>
          <span className={degree}>2</span>
        </div>
      </div>
      <Divider />
    </>
  )
}

const styles = () => ({
  editorContainer: {
    padding: '8px 24px 16px'
  },
  editorTitle: {
    marginLeft: -8,
    marginBottom: 4,
    fontSize: '1rem'
  },
  numberBox: {
    width: '51%',
    '& .dx-texteditor-input-container': {
      paddingLeft: '0.5rem',
    }
  },
  fieldWrapper: {
    display: 'flex'
  },
  units: {
    transform: 'translate(0.7rem, 0.8125rem)',
    fontSize: '0.875rem',
    fontFamily: 'Roboto',
    fontWeight: 500,
  },
  degree: {
    transform: 'translate(0.875rem, 0.5rem)',
    fontSize: '0.65rem',
  }
});

export default compose(withStyles(styles))(React.memo(CircleDetail, areEqual));
